var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.307 10.87C12.207 10.86 12.087 10.86 11.977 10.87C9.59703 10.79 7.70703 8.84 7.70703 6.44C7.70703 3.99 9.68703 2 12.147 2C14.597 2 16.587 3.99 16.587 6.44C16.577 8.84 14.687 10.79 12.307 10.87Z",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.30719 14.56C4.88719 16.18 4.88719 18.82 7.30719 20.43C10.0572 22.27 14.5672 22.27 17.3172 20.43C19.7372 18.81 19.7372 16.17 17.3172 14.56C14.5772 12.73 10.0672 12.73 7.30719 14.56Z",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconProfile);
export default __webpack_public_path__ + "static/media/profile-icon-profile.251815cb2340a7d29838e29d11249896.svg";
export { ForwardRef as ReactComponent };